import icon from './icons'

export default icon
